import { useUsersByRole } from '@/app/hooks/useUsersByRole'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useLocation, useParams } from 'react-router-dom'

export const ManagerDetailsPageController = () => {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  const { managerName } = location.state || {}
  const { ref, inView } = useInView()

  const {
    data,
    isLoading,
    setParams,
    fetchNextPage,
    isFetching,
    hasNextPage,
    isFetchingNextPage,
  } = useUsersByRole('SUPERVISOR')

  useEffect(() => {
    if (id) {
      setParams((prev) => ({
        ...prev,
        managerIds: id,
      }))
    }
  }, [id, setParams])

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    ref,
    data,
    isFetching,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    managerName,
  }
}
